import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-arrears-grid',
  templateUrl: './payment-arrears-grid.component.html',
  styleUrls: ['./payment-arrears-grid.component.css']
})
export class PaymentArrearsGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/payment-arrears/payment-arrears-grid/payment-arrears-grid.component.ts